// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.popup-container.transcription-plugin-popup .popup-content.static-position {
    opacity: 0.6;
}

.popup-container.transcription-plugin-popup .popup-content {
    opacity: 1;
}

.popup-container.transcription-plugin-popup:hover .popup-content {
    opacity: 1;
}

.transcriptions-container {
    min-width: 300px;
}

.transcriptions-container input {
    width: 100%;
}
.popup-container.transcription-plugin-popup .popup-content {
    width: 50vw;
}

.popup-container.transcription-plugin-popup .popup-content .transcriptions-container {
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    /* opacity: 1; */
    color: #ffffff;
    font-size: 14px;
    height: 100%
}

.popup-container.transcription-plugin-popup .popup-content.static-position .transcriptions-container {
    max-height: unset; 
}

.transcriptions-list {
    overflow-y: auto;
}


.transcriptions-container ul {    
    margin-block-start: 5px;
    margin-block-end: 5px;
    margin-inline-start: 3px;
    padding-inline-start: 0px;
}
 
.transcriptions-container ul li {
    display: flex;
    gap: 3px;
    margin-top: 3px;
    margin-right: 3px;
    padding-left: 5px;
    padding-right: 5px;
    border: 1px rgba(0,0,0,0) solid;
}

.transcriptions-container ul li:hover {
    border: 1px lightsalmon dashed;
    cursor: pointer;
}

.transcriptions-container ul li img {
    max-width: 160px;
    max-height: 90px;
} 
`, "",{"version":3,"sources":["webpack://./src/css/TranscriptionsPlugin.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["\n.popup-container.transcription-plugin-popup .popup-content.static-position {\n    opacity: 0.6;\n}\n\n.popup-container.transcription-plugin-popup .popup-content {\n    opacity: 1;\n}\n\n.popup-container.transcription-plugin-popup:hover .popup-content {\n    opacity: 1;\n}\n\n.transcriptions-container {\n    min-width: 300px;\n}\n\n.transcriptions-container input {\n    width: 100%;\n}\n.popup-container.transcription-plugin-popup .popup-content {\n    width: 50vw;\n}\n\n.popup-container.transcription-plugin-popup .popup-content .transcriptions-container {\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    /* opacity: 1; */\n    color: #ffffff;\n    font-size: 14px;\n    height: 100%\n}\n\n.popup-container.transcription-plugin-popup .popup-content.static-position .transcriptions-container {\n    max-height: unset; \n}\n\n.transcriptions-list {\n    overflow-y: auto;\n}\n\n\n.transcriptions-container ul {    \n    margin-block-start: 5px;\n    margin-block-end: 5px;\n    margin-inline-start: 3px;\n    padding-inline-start: 0px;\n}\n \n.transcriptions-container ul li {\n    display: flex;\n    gap: 3px;\n    margin-top: 3px;\n    margin-right: 3px;\n    padding-left: 5px;\n    padding-right: 5px;\n    border: 1px rgba(0,0,0,0) solid;\n}\n\n.transcriptions-container ul li:hover {\n    border: 1px lightsalmon dashed;\n    cursor: pointer;\n}\n\n.transcriptions-container ul li img {\n    max-width: 160px;\n    max-height: 90px;\n} \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
